/**
 * Generated runtime TestId mirror for frontend/src/components/shared/JobBreadcrumbs.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const JobBreadcrumbsTestIds = {
  jobBreadcrumbs: "job-breadcrumbs",
  breadcrumb: (index: number) => `breadcrumb-${index}`,
  breadcrumbPrefix: () => "breadcrumb-" as TestIdPrefix
} as const;
